module.exports = __webpack_public_path__ + "img/dante-wrath.a8cdede0.jpg";